import {Component, EventEmitter, Input, Output} from '@angular/core';
import {polstRejectReasonsData} from "../../static/polst-reject-reasons";
import {adRejectReasonsData} from "../../static/ad-reject-reasons";
import {FormBuilder, FormControl} from "@angular/forms";

@Component({
    selector: 'app-reject-reasons-form',
    templateUrl: './reject-reasons-form.component.html',
    styleUrls: ['./reject-reasons-form.component.scss'],
    standalone: false
})
export class RejectReasonsFormComponent {
  @Input() formType: any;
  @Output() valuesChange = new EventEmitter<string[]>();
  public adRejectReasons = adRejectReasonsData;
  public polstRejectReasons = polstRejectReasonsData;
  public rejectReasonsSelected = [];
  public rejectReasonsForm = this.formBuilder.group({
    freeText: new FormControl(),
  });
  constructor(private formBuilder: FormBuilder) {}
  public onRejectReasonChecked(txt: any, ev: any) {
    if (ev.target.checked) {
      this.rejectReasonsSelected.push(txt);
    } else {
      const index = this.rejectReasonsSelected.findIndex(e => e === txt);
      this.rejectReasonsSelected.splice(index, 1);
    }
  }
  public getRejectReasonsValue() {
    const rejectReasons = [];
    this.rejectReasonsSelected.forEach(r => {
      rejectReasons.push(r);
    });
    const otherText = this.rejectReasonsForm.get('freeText').value;
    if (otherText !== null && otherText !== undefined && otherText.length !== 0) {
      rejectReasons.push(otherText);
    }
    this.valuesChange.emit(rejectReasons);
  }
}
